<template>
  <div class="table-responsive">
    <table class="table table-striped table-light table-hover align-middle">
      <caption>{{ caption }}</caption>
      <thead>
      <tr>
        <th v-for="col in this.cols"
            :key="col.key"
            :class="{'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
            scope="col" @click="sort(col)"
            v-html="title(col.title, col.key, col.sortable)">
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="el in this.data" :key="el.id">
        <td v-for="col in this.cols" :key="col.key"
            :class="{'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}">
          <span v-if="col.func">{{ col.func(el) }}</span>
          <input v-else-if="col.type === 'text'" v-model.lazy="el[col.key]"
                 :class="{'form-control-plaintext': selectedElementId !== el.id || col.nonEditable, 'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
                 :disabled="col.nonEditable"
                 :readonly="selectedElementId !== el.id || col.nonEditable"
                 class="form-control"
                 type="text"
                 @blur="el[col.key] = this.update(el, col)"
                 @focus="this.startEditing(el, col)"
                 @keyup.esc="this.abortEditing()">
          <input v-else-if="col.type === 'checkbox'" v-model="el[col.key]"
                 :class="{'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
                 type="checkbox"
                 :disabled="col.nonEditable"
                 @change="this.update(el, col)">
          <input v-else-if="col.type === 'number'" v-model.lazy="el[col.key]"
                 :class="{'form-control-plaintext': selectedElementId !== el.id || col.nonEditable, 'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
                 :disabled="col.nonEditable"
                 :readonly="selectedElementId !== el.id || col.nonEditable"
                 class="form-control"
                 type="number"
                 @blur="el[col.key] = this.update(el, col)"
                 @focus="this.startEditing(el, col)"
                 @keyup.esc="this.abortEditing()">
          <input v-else-if="col.type === 'datetime'"
                 :class="{'form-control-plaintext': selectedElementId !== el.id || col.nonEditable, 'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
                 :disabled="col.nonEditable"
                 :readonly="selectedElementId !== el.id || col.nonEditable"
                 :value="el[col.key] && el[col.key].slice(0, 16)"
                 class="form-control"
                 type="datetime-local"
                 @blur="el[col.key] = this.update(el, col)"
                 @focus="this.startEditing(el, col)"
                 @input="el[col.key] = $event.target.value"
                 @keyup.esc="this.abortEditing()">
          <input v-else-if="col.type === 'date'" v-model.lazy="el[col.key]"
                 :class="{'form-control-plaintext': selectedElementId !== el.id || col.nonEditable, 'text-start': col.alignment === 'start', 'text-end': col.alignment === 'end', 'text-center': col.alignment === 'center'}"
                 :disabled="col.nonEditable"
                 :readonly="selectedElementId !== el.id || col.nonEditable"
                 class="form-control"
                 type="date"
                 @blur="el[col.key] = this.update(el, col)"
                 @focus="this.startEditing(el, col)"
                 @keyup.esc="this.abortEditing()">
          <slot v-else-if="col.type === 'inject'" :id="el.id" :el="el" :name="col.key"></slot>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "VueDataTable",
  props: ["caption", "cols", "data", "store"],
  emits: ["sort", "update"],
  data: function () {
    return {
      selectedElementId: null,
      tempVal: null,
      abortUpdate: false,
    }
  },
  methods: {
    title(title, col, sortable) {
      if (!sortable)
        return title;
      let res = `${title}`;
      let el = this.store.currentSort.find(a => a.col === col);
      if (el) {
        let dir = el.sortDir === 'asc' ? 'up' : 'down';
        res += ` <em class="align-middle material-icons">arrow_drop_${dir}</em><sub>${this.store.currentSort.length - this.store.currentSort.indexOf(el)}.</sub>`;
      }
      return res;
    },
    sort(col) {
      if (col.sortable)
        this.$emit('sort', col.key);
    },
    startEditing(el, col) {
      this.selectedElementId = el.id;
      this.tempVal = el[col.key];
    },
    update(el, col) {
      if (!this.abortUpdate && el[col.key] !== this.tempVal) {
        this.$emit('update', el);
      }
      let res = this.abortUpdate ? this.tempVal : el[col.key]
      this.abortUpdate = false;
      this.tempVal = null;
      this.selectedElementId = null;
      return res;
    },
    abortEditing() {
      this.abortUpdate = true;
      document.activeElement.blur();
    }
  },
}

</script>

<style scoped>
.form-control:disabled {
  background-color: unset;
}
</style>